import { render } from "./SouTiens.vue?vue&type=template&id=3a9f4adc&scoped=true&ts=true"
import script from "./SouTiens.vue?vue&type=script&lang=ts"
export * from "./SouTiens.vue?vue&type=script&lang=ts"

import "./SouTiens.vue?vue&type=style&index=0&id=3a9f4adc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a9f4adc"]])

export default __exports__